import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyB3PlBXC3x8NVhvITXBc7ITIutTMXMzrRQ",
  authDomain: "kayla-butik-3e3fa.firebaseapp.com",
  projectId: "kayla-butik-3e3fa",
  storageBucket: "kayla-butik-3e3fa.firebasestorage.app",
  messagingSenderId: "449242123550",
  appId: "1:449242123550:web:309646c1a8e8aca67d8d0f",
  measurementId: "G-KBRZFTYWKZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

export default app; 